import { TagValues } from "@/model/data/Tag";
import { MaintenanceStatusEnum } from "@/model/data/status/MaintenanceStatusEnum";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { IFilterInstallations } from "../supportObjects/IFilterInstallations";
import { IPaginationFilter } from "../supportObjects/IPaginationFilter";
import { FetchInstallationsPreventiveMaintenanceStatusResponse } from "./FetchInstallationsPreventiveMaintenanceStatusResponse";

const ENDPOINT = "/maintenance";

export class FetchInstallationsPreventiveMaintenanceStatusCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: FetchInstallationsPreventiveMaintenanceStatusReqData;

    constructor(payload: FetchInstallationsPreventiveMaintenanceStatusReqData) {
        super();
        this.payload = payload;
    }

    public async execute(): Promise<FetchInstallationsPreventiveMaintenanceStatusResponse> {
        let res = await this.executeCommand(this.payload);
        return new FetchInstallationsPreventiveMaintenanceStatusResponse(res);
    }
}

export class FetchInstallationsPreventiveMaintenanceStatusReqData implements IFilterInstallations, IPaginationFilter {
    // FilterInstallations
    installationNames: string[] = null;
    folderIds: number[] = null;
    branchNames: string[] = [];

    // PaginationFilters
    queryLimit: number = 0;
    offset: number = 0;
    orderBy: string[] = null;
    orderByDescending: boolean[] = null;

    // Other filters
    installationLastMessageDateRange: string[] = [];
    agentLastMessageDateRange: string[] = [];
    machineModels: string[] = null;
    tagValues: TagValues = null;
    maintenanceStatusList: MaintenanceStatusEnum[] = [];
}
